import React from "react";
import * as Styled from "./styles.js";

function SizeItem({ title, image, isSelected, onClick }) {
  return (
    <Styled.Container isSelected={isSelected} onClick={onClick} width="165px">
      <Styled.SizeImage src={image} alt="size"></Styled.SizeImage>
      <Styled.Title>{title}</Styled.Title>
    </Styled.Container>
  );
}

export default SizeItem;
